import { jsx as _jsx } from "react/jsx-runtime";
import { createDrawerNavigator } from "@react-navigation/drawer";
import React from "react";
import { withLayoutContext } from "./withLayoutContext";
var DrawerNavigator = createDrawerNavigator().Navigator;
var RNDrawer = withLayoutContext(DrawerNavigator);
var DrawerWithRender = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  return /* @__PURE__ */ _jsx(RNDrawer, {
    ...props,
    ref
  });
});
var Drawer = Object.assign(DrawerWithRender, {
  Screen: RNDrawer.Screen
});
var Drawer_default = Drawer;
export {
  Drawer,
  Drawer_default as default
};
//# sourceMappingURL=Drawer.js.map
